var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAptive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5347 11.7386C9.42578 12.6139 8.15056 13 6.79218 13C4.79618 13 2.91107 12.1762 1.71902 10.8891C0.665576 9.75644 0.000244141 8.21188 0.000244141 6.51287C0.000244141 2.83168 2.93879 0 6.59812 0C8.12284 0 9.48123 0.463366 10.5347 1.26139V0.257426H13.9999V12.7426H10.5347V11.7386ZM3.60418 6.51274C3.60418 8.46918 5.1289 9.91076 7.15262 9.91076C8.511 9.91076 9.70306 9.29294 10.3961 8.36621V4.63353C9.64761 3.7068 8.45556 3.08898 7.06945 3.08898C4.96257 3.08898 3.60418 4.71076 3.60418 6.51274Z",
    fill: "#111827"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAptive);
export default __webpack_public_path__ + "static/media/aptive.0f70e6a0b308752b356ff1b75ec0e974.svg";
export { ForwardRef as ReactComponent };